import { useContext } from 'react';
import { LabelPrefixContext } from './LabelPrefixContext';
export var useLabelPrefix = function () { return useContext(LabelPrefixContext); };
//# sourceMappingURL=useLabelPrefix.js.map